import { render, staticRenderFns } from "./PopUpSuccessForm.vue?vue&type=template&id=10c87ac2&scoped=true&"
import script from "./PopUpSuccessForm.vue?vue&type=script&lang=js&"
export * from "./PopUpSuccessForm.vue?vue&type=script&lang=js&"
import style0 from "./PopUpSuccessForm.vue?vue&type=style&index=0&id=10c87ac2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c87ac2",
  null
  
)

export default component.exports